import type { Nullable } from "models-webgl2";
import { Webgl2Component } from "../../webgl2-component";

export const getRootParent = (
  component: Nullable<Webgl2Component<any, any>>,
): Webgl2Component<any, any>[] => {
  if (!component) return [];
  const parentsPath: Webgl2Component<any, any>[] = [component];
  return parentsPath.concat(getRootParent(component.parent));
};
